export default {
  storesInfo: [],
  userCoords: [23.546162, 120.6402133], // 預設
  searchedKeywords: ""
};
